import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const RoomSizeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RoomSizeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.3486 21.3434H5.19141C3.58057 21.3434 2.27002 20.0328 2.27002 18.4225V6.48206C2.27002 4.87073 3.58057 3.56018 5.19141 3.56018H19.3486C20.9595 3.56018 22.27 4.87073 22.27 6.48206V18.4225C22.27 20.0328 20.9595 21.3434 19.3486 21.3434ZM5.19141 4.56019C4.13184 4.56019 3.27002 5.42249 3.27002 6.48207V18.4225C3.27002 19.4821 4.13184 20.3434 5.19141 20.3434H19.3486C20.4082 20.3434 21.27 19.4821 21.27 18.4225V6.48206C21.27 5.42249 20.4082 4.56018 19.3486 4.56018L5.19141 4.56019Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.4448 12.9127H6.09522C5.81885 12.9127 5.59522 12.6891 5.59522 12.4127C5.59522 12.1364 5.81885 11.9127 6.09522 11.9127H18.4448C18.7212 11.9127 18.9448 12.1364 18.9448 12.4127C18.9448 12.6891 18.7212 12.9127 18.4448 12.9127Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.8613 14.8912C16.7519 14.8912 16.6416 14.8551 16.5493 14.7819C16.334 14.609 16.2988 14.2946 16.4712 14.0787L17.8047 12.4127L16.4712 10.7457C16.2988 10.5299 16.334 10.2155 16.5493 10.0426C16.7651 9.87073 17.0791 9.90589 17.2524 10.1207L18.8354 12.1002C18.9814 12.2828 18.9814 12.5426 18.8354 12.7252L17.2524 14.7037C17.1533 14.8268 17.0083 14.8912 16.8613 14.8912Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.67871 14.8912C7.53174 14.8912 7.38672 14.8268 7.2876 14.7037L5.70459 12.7252C5.55859 12.5426 5.55859 12.2828 5.70459 12.1002L7.2876 10.1207C7.46094 9.90686 7.77539 9.87073 7.99072 10.0426C8.20605 10.2155 8.24121 10.5299 8.06884 10.7457L6.73534 12.4127L8.06884 14.0787C8.2412 14.2946 8.20605 14.609 7.99072 14.7819C7.89843 14.8551 7.78808 14.8912 7.67871 14.8912Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default RoomSizeIcon;
